

const setZoom = (value: number) => ({
    type: 'ZOOM/SET_ZOOM',
    value,
});


export {
    setZoom,
};
